import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import * as React from "react";
import { useMutation, useQuery, useQueryClient } from "react-query";
import {
  ApiResultModel,
  ColumnModel,
  PageInfoModel,
} from "../../models/common.model";

import createCache from "@emotion/cache";
import { CacheProvider, ThemeProvider } from "@emotion/react";
import { createStyles, makeStyles } from "@material-ui/core";
import MoreHorizIcon from "@mui/icons-material/MoreHoriz";
import { Box, Button, Grid, Tooltip } from "@mui/material";
import Pagination from "@mui/material/Pagination";
import PaginationItem from "@mui/material/PaginationItem";
import { createTheme } from "@mui/material/styles";
import { Formik } from "formik";
import { useState } from "react";
import { connect, useSelector } from "react-redux";
import { useHistory, withRouter } from "react-router-dom";
import { prefixer } from "stylis";
import rtlPlugin from "stylis-plugin-rtl";
import ChipCmp from "../../components/chip/chipCmp";
import Autocomplate from "../../components/dropdown/Autocomplate";
import MultiSelectChip from "../../components/dropdown/MultiSelectChip";
import MaterialTextFieldComponent from "../../components/textField/MaterialTextFieldCmp";
import {
  LOAN_REQUEST_STATUS_SETAD,
  LOAN_TEMPLATE_SETAD,
  SUPPLIERIDS,
  SUPPLIER_ATTACHMENTS_UPLOADED,
  SUPPLIER_SETTLEMENT_STATUS_SETAD,
  TABLE_FILTER_SUPP,
  TABLE_FILTER_SUPP_ROWNumber,
  WORK_FLOW_TYPE,
} from "../../config/cacheKey";
import { GetStatusResponse } from "../../models/basicInformation.model";
import { FilterFinder, PaginationInfo } from "../../models/cartable.model";
import {
  Filter,
  GetOnlineInstallmentReportRequest,
  GetOnlineInstallmentReportResponse,
} from "../../models/report.model";
import {
  GetLoanRequestStatus,
  GetLoanTemplatesForSetad,
  GetSupplierSettlementStatus,
  GetSuppliers,
} from "../../services/basicInformation.service";
import {
  GetOnlineInstallmentReport,
  GetOnlineInstallmentReportExcel,
} from "../../services/report.service";

const useStyles = makeStyles((theme) =>
  createStyles({
    select: {
      "&.Mui-selected": {
        backgroundColor: muiSelected,
      },
    },
  })
);

const nextIcon = () => {
  return (
    <img style={{ height: "12px", width: "10px" }} src="images/Next.png" />
  );
};
const previusIcon = () => {
  return (
    <img style={{ height: "12px", width: "10px" }} src="images/Previous.png" />
  );
};

const theme = createTheme({
  direction: "rtl", // Both here and <body dir="rtl">
});
// Create rtl cache
const cacheRtl = createCache({
  key: "muirtl",
  stylisPlugins: [prefixer, rtlPlugin],
});

const columns: readonly ColumnModel[] = [
  { id: "fullName", label: "متقاضی" },
  { id: "nationalCode", label: "کد ملی" },
  {
    id: "mobileNumber",
    label: "شماره همراه",
  },
  {
    id: "loanTemplateTitle",
    label: "طرح تسهیلات",
  },
  {
    id: "supplierTitle",
    label: " پذیرنده ",
  },
  {
    id: "financialSupplierTitle",
    label: "منبع مالی",
  },
  {
    id: "loanAmount",
    label: "مبلغ تسهیلات (ریال)",
    hasFormat: true,
    format: (value: number) => {
      return value.toLocaleString("fa");
    },
  },
  {
    id: "installmentAmount",
    label: " مبلغ قسط (ریال)",
    hasFormat: true,
    format: (value: number) => {
      return value.toLocaleString("fa");
    },
  },
  {
    id: "installmentCount",
    label: "تعداد اقساط ",
  },
  {
    id: "paidInstallmentCount",
    label: "تعداد اقساط پرداخت شده",
  },
  {
    id: "lastPaymentDate_Persian",
    label: "تاریخ آخرین پرداخت قسط",
  },
  {
    id: "overduedInstallmentCount",
    label: "تعداد اقساط سر رسید شده",
  },
  {
    id: "overduedInstallmentAmount",
    label: "جمع اقساط سررسید شده (ریال)",
    hasFormat: true,
    format: (value: number) => {
      return value.toLocaleString("fa");
    },
  },
  {
    id: "penaltyAmount",
    label: "مجموع جریمه (ریال)",
    hasFormat: true,
    format: (value: number) => {
      return value.toLocaleString("fa");
    },
  },
  {
    id: "totalOverDuedDeptAmount",
    label: "مبلغ بدهی سررسید شده (ریال)",
    hasFormat: true,
    format: (value: number) => {
      return value.toLocaleString("fa");
    },
  },
];
let muiSelected: any;

function TableOnlineInstallment({
  stateCartable,
  status,
}: TableCmpPropsInterface) {
  const jsonFile = useSelector((state: any) => state.style);

  muiSelected = jsonFile?.muiSelected;

  let row: any;
  const queryClient = useQueryClient();
  const classes = useStyles();
  const activePage = localStorage.getItem("setActivePage");
  queryClient.setQueryData(WORK_FLOW_TYPE, undefined);
  const oldPage = queryClient.getQueryData<FilterFinder>(
    TABLE_FILTER_SUPP_ROWNumber
  );

  const history = useHistory<{
    from: string;
    id: string;
    pageNumber: number;
    clickOnBack: boolean;
  }>();
  const [
    valueCustomerNationalCode,
    setValueCustomerNationalCode,
  ] = React.useState<string>();
  const [valueFilterData, setValueFilterData] = React.useState<Filter>();
  const [valueLoanTemplateOptions, setValueLoanTemplateOptions] = useState<
    number[]
  >([]);
  const [valueSupplierIds, setValueSupplierIds] = useState<number[]>([]);
  const [valueSupplier, setValueSupplier] = useState<any[]>([]);

  const [selectedRow, setSelectedRow] = useState(undefined);
  const [data, setData] = React.useState<GetOnlineInstallmentReportResponse[]>(
    []
  );
  const [pageInfo, setPageInfo] = React.useState<PageInfoModel>(
    (): PageInfoModel => {
      let pageInfoModel = new PageInfoModel();
      pageInfoModel.pageNumber = -1;
      pageInfoModel.pageSize = 10;
      pageInfoModel.total = 0;

      return pageInfoModel;
    }
  );
  const [currentPaginationInfo, setCurrentPaginationInfo] = React.useState(
    (): PaginationInfo => {
      let paginationInfo = new PaginationInfo();
      paginationInfo.pageNumber = 1;
      return paginationInfo;
    }
  );

  const [loanTemplateOptions, setLoanTemplateOptions] = React.useState<
    GetStatusResponse[]
  >([]);
  const [loanRequestStatus, setLoanRequestStatus] = React.useState<
    GetStatusResponse[]
  >([]);

  const [
    supplierSettlementOptions,
    setSupplierSettlementOptions,
  ] = React.useState<GetStatusResponse[]>([]);
  const [supplierIdsOptions, setSupplierIdsOptions] = React.useState<
    GetStatusResponse[]
  >([]);

  const previousPage =
    history.location.state !== undefined ? history.location.state.from : null;

  React.useEffect(() => {
    if (history.action === "POP" && oldPage?.rowNumber != undefined) {
      row = queryClient.getQueryData(TABLE_FILTER_SUPP_ROWNumber);
      setSelectedRow(row?.rowNumber);
    }
    if (
      (history.action === "PUSH" || history.action === "REPLACE") &&
      oldPage?.rowNumber == undefined
    ) {
      row = undefined;
      setSelectedRow(row);
    }
    if (history.action === "POP" && oldPage?.rowNumber == undefined) {
      row = undefined;
      setSelectedRow(row);
    }
    if (
      (history.action === "PUSH" || history.action === "REPLACE") &&
      oldPage?.rowNumber != undefined
    ) {
      row = queryClient.getQueryData(TABLE_FILTER_SUPP_ROWNumber);
      setSelectedRow(row?.rowNumber);
    }
    let filterData;

    if (
      previousPage !== null ||
      (history.action === "REPLACE" &&
        history.location.state !== undefined &&
        history.location.state.clickOnBack)
    ) {
      filterData = queryClient.getQueryData<Filter>(TABLE_FILTER_SUPP);
      if (filterData !== undefined && filterData !== null) {
        setValueLoanTemplateOptions(filterData?.loanTemplateIds!);
        setValueSupplierIds(filterData?.supplierIds!);
        setValueCustomerNationalCode(filterData?.nationalCode!);
      }
    } else {
      // filter.state = stateCartable.stateCartable;
      filterData = new Filter();
      filterData.loanTemplateIds = [];
      filterData.supplierIds = [];
      queryClient.setQueryData(TABLE_FILTER_SUPP, null);
    }
    fillData(filterData!);
    const filterSupp = new FilterFinder();
    filterSupp.state = stateCartable.stateCartable;
    queryClient.setQueryData(TABLE_FILTER_SUPP_ROWNumber, filterSupp);
  }, [stateCartable]);

  useQuery<GetStatusResponse[]>(LOAN_TEMPLATE_SETAD, GetLoanTemplatesForSetad, {
    onSuccess(data) {
      setLoanTemplateOptions(data);
    },
  });
  useQuery<GetStatusResponse[]>(
    LOAN_REQUEST_STATUS_SETAD,
    GetLoanRequestStatus,
    {
      onSuccess(data) {
        setLoanRequestStatus(data);
      },
    }
  );
  useQuery<GetStatusResponse[]>(
    SUPPLIER_SETTLEMENT_STATUS_SETAD,
    GetSupplierSettlementStatus,
    {
      onSuccess(data) {
        setSupplierSettlementOptions(data);
      },
    }
  );
  useQuery<GetStatusResponse[]>(SUPPLIERIDS, GetSuppliers, {
    onSuccess(data) {
      setSupplierIdsOptions(data);
    },
  });
  const GetOnlineInstallmentReportMutation = useMutation(
    GetOnlineInstallmentReport,
    {
      onSuccess: (
        result: ApiResultModel<GetOnlineInstallmentReportResponse[]>
      ) => {
        if (result) {
          setData(result.data);
          setPageInfo(result.pageInfo);
        }
      },
    }
  );

  const GetOnlineInstallmentReportExcelsMutation = useMutation(
    GetOnlineInstallmentReportExcel,
    {
      onSuccess: (result) => {},
      onError: (e) => {},
    }
  );

  const setChildValueLoanTemplate = (childValues: any) => {
    const selectedItem = valueLoanTemplateOptions.filter(
      (item: any) => item != childValues
    );
    setValueLoanTemplateOptions(selectedItem);
    const tabelFilter = queryClient.getQueryData<Filter>(TABLE_FILTER_SUPP);
    if (tabelFilter != undefined && tabelFilter != null) {
      tabelFilter!.loanTemplateIds = tabelFilter!.loanTemplateIds
        ?.filter((item: any) => item != childValues)
        .map((items: any) => {
          return items;
        });
    }
    fillData(tabelFilter!);
  };
  const setChildValueSupplierIds = (childValues: any) => {
    const selectedItem = valueSupplierIds.filter(
      (item: any) => item != childValues
    );
    const selectedItemValue = valueSupplier.filter(
      (item: any) => item.id != childValues
    );
    setValueSupplierIds(selectedItem);
    setValueSupplier(selectedItemValue);
    const tabelFilter = queryClient.getQueryData<Filter>(TABLE_FILTER_SUPP);
    if (tabelFilter != undefined && tabelFilter != null) {
      tabelFilter!.supplierIds = tabelFilter!.supplierIds
        ?.filter((item: any) => item != childValues)
        .map((items: any) => {
          return items;
        });
    }

    fillData(tabelFilter!);
  };

  const setChildValueCustomerNationalCode = (childValues: any) => {
    const selectedItem = "";
    setValueCustomerNationalCode(selectedItem);
    const tabelFilter = queryClient.getQueryData<Filter>(TABLE_FILTER_SUPP);
    if (tabelFilter != undefined && tabelFilter != null)
      tabelFilter!.nationalCode = undefined;
    fillData(tabelFilter!);
  };

  const generateFilter = (filterData: Filter): any => {
    let request = new GetOnlineInstallmentReportRequest();
    request.paginationInfo = currentPaginationInfo;
    request.filter = filterData;
    if (request.filter != undefined) {
      //request.filter.cartableTitle = "پرونده های تسهیلات";
      return request;
    } else {
      const filter = new Filter();
      filter.supplierIds = [];
      filter.loanTemplateIds = [];
      filter.nationalCode = "";
      request.filter = filter;
      return request;
    }
  };

  const fillData = (filterData: Filter) => {
    let filter = generateFilter(filterData);
    GetOnlineInstallmentReportMutation.mutate(filter);
    setValueFilterData(filter?.filter);
  };

  const changePageNumber = (newPageNumber: number) => {
    const tabelFilter = queryClient.getQueryData<Filter>(TABLE_FILTER_SUPP);
    fillData(tabelFilter!);
    currentPaginationInfo.pageNumber = newPageNumber;
    setCurrentPaginationInfo(currentPaginationInfo);
  };

  const handleChangePagination = (event: any, value: any) => {
    changePageNumber(value);
    handleSelectRow(undefined);
  };
  const handleDetail = (referenceKey: string, rowIndex: number) => {
    window.sessionStorage.setItem("idFind", referenceKey);
    // window.sessionStorage.setItem("loanRequestId", loanRequestId.toString());
    handleSelectRow(rowIndex);
    // currentPaginationInfo.rowNumber = rowIndex;
    queryClient.setQueryData(SUPPLIER_ATTACHMENTS_UPLOADED, null);
    //history.push(`/loan-detail/${referenceKey}`);
    history.push({
      pathname: `/Report/${activePage}1/report-detail`,
      state: {
        id: referenceKey,
        from: "",
        pageNumber: currentPaginationInfo.pageNumber!,
        clickOnBack: false,
      },
      // search: "test",
    });
  };
  const handleSelectRow = (rowIndex: any) => {
    const cachPageNumber = queryClient.getQueryData(
      TABLE_FILTER_SUPP_ROWNumber
    ) as FilterFinder;
    const filter = new FilterFinder();
    filter.rowNumber = rowIndex;
    setSelectedRow(rowIndex);
    queryClient.setQueryData(TABLE_FILTER_SUPP_ROWNumber, filter);
  };
  function changeValueLoanTemplateOptions(e: any) {
    setValueLoanTemplateOptions(e);
  }
  function changeValueSupplierIds(e: any, value: any) {
    setValueSupplierIds(e);
    setValueSupplier(value);
  }
  function changeValueCustomerNationalCode(e: any) {
    setValueCustomerNationalCode(e.currentTarget.value);
  }

  function deleteChip() {
    setValueLoanTemplateOptions([]);
    setValueSupplierIds([]);
    setValueCustomerNationalCode("");
    queryClient.setQueryData(TABLE_FILTER_SUPP, null);
    fillData(queryClient.getQueryData(TABLE_FILTER_SUPP)!);
    currentPaginationInfo.pageNumber = 1;
    setCurrentPaginationInfo(currentPaginationInfo);
  }
  const filter = new Filter();
  // filter.state = " []";
  filter.supplierIds = [];
  filter.loanTemplateIds = [];

  const [isShow, setIsShow] = useState(true);
  let handelFilter = () => {
    setIsShow(!isShow);
  };

  let exportExcel = () => {
    GetOnlineInstallmentReportExcelsMutation.mutate(
      valueFilterData ? valueFilterData! : new Filter()
    );
  };
  return (
    <div>
      <Tooltip title="فیلتر" arrow>
        <img
          onClick={handelFilter}
          style={{ width: "24px", height: "24px", marginBottom: ".5vh" }}
          src="images/filter.png"
        />
      </Tooltip>
      <span style={{ margin: "2vh", color: "#CFD8DC" }}>|</span>
      <Tooltip title="خروجی اکسل" arrow>
        <img
          onClick={exportExcel}
          className="cursorPointer"
          style={{ width: "24px", height: "24px", marginBottom: ".5vh" }}
          src="images/ExportXLS.svg"
        />
      </Tooltip>
      {isShow ? (
        <Box sx={{ flexGrow: 1 }}>
          <Formik
            initialValues={filter}
            onSubmit={(values) => {
              queryClient.setQueryData(TABLE_FILTER_SUPP, values);
              values.loanTemplateIds = valueLoanTemplateOptions;
              values.supplierIds = valueSupplierIds;
              values.nationalCode = valueCustomerNationalCode;
              fillData(values);
              currentPaginationInfo.pageNumber = 1;
              setCurrentPaginationInfo(currentPaginationInfo);
            }}
          >
            {({ handleSubmit, handleChange, values }) => (
              <form onSubmit={handleSubmit}>
                <div className="row">
                  <div
                    className="col-lg-2 col-md-4 col-sm-6 col-xs-12 col-12"
                    style={{ marginTop: "1vh" }}
                  >
                    <MaterialTextFieldComponent
                      helperText={""}
                      placeHolder={"کد ملی"}
                      label={"کد ملی "}
                      required={false}
                      value={valueCustomerNationalCode}
                      onChange={changeValueCustomerNationalCode}
                      name="customerNationalCode"
                      id="customerNationalCode"
                    />
                  </div>
                  <div
                    className="col-lg-2 col-md-4 col-sm-6 col-xs-12 col-12"
                    style={{ marginTop: "1vh" }}
                  >
                    <CacheProvider value={cacheRtl}>
                      <ThemeProvider theme={theme}>
                        <div>
                          <Autocomplate
                            id="supplierIds"
                            name="supplierIds"
                            value={valueSupplierIds}
                            label="پذیرنده"
                            options={supplierIdsOptions}
                            onChange={changeValueSupplierIds}
                            changeMultiSelect={changeValueSupplierIds}
                            responseValue={valueSupplier}
                          />
                        </div>
                      </ThemeProvider>
                    </CacheProvider>
                  </div>
                  <div
                    className="col-lg-2 col-md-4 col-sm-6 col-xs-12 col-12"
                    style={{ marginTop: "1vh" }}
                  >
                    <CacheProvider value={cacheRtl}>
                      <ThemeProvider theme={theme}>
                        <div dir="rtl">
                          <MultiSelectChip
                            id="loanTemplateOptions"
                            name="loanTemplateOptions"
                            value={valueLoanTemplateOptions}
                            label="طرح تسهیلات"
                            options={loanTemplateOptions}
                            onChange={changeValueLoanTemplateOptions}
                            changeMultiSelect={changeValueLoanTemplateOptions}
                          />
                        </div>
                      </ThemeProvider>
                    </CacheProvider>
                  </div>
                  <div
                    className="col-lg-2 col-md-4 col-sm-6 col-xs-12 col-12 butFilter"
                    style={{ marginTop: "1vh" }}
                  >
                    <Button
                      fullWidth
                      variant="contained"
                      type="submit"
                      className="btnForm SuccessDefault  "
                    >
                      اعمال فیلتر
                    </Button>
                  </div>
                </div>
                {valueLoanTemplateOptions?.length ||
                valueSupplierIds?.length ||
                valueCustomerNationalCode ? (
                  <div className="row tableCMP">
                    <Button
                      onClick={deleteChip}
                      style={{
                        justifyContent: "right",
                        minWidth: "25px",
                        marginRight: "-1vh",
                      }}
                    >
                      <img
                        style={{ height: "24px", width: "24px" }}
                        src="images/RemoveAllFilters.svg"
                      />
                    </Button>
                    <ChipCmp
                      item={valueLoanTemplateOptions}
                      enamValue={loanTemplateOptions}
                      index={valueLoanTemplateOptions?.length}
                      setChildValue={setChildValueLoanTemplate}
                    />
                    <ChipCmp
                      item={valueSupplierIds}
                      enamValue={supplierIdsOptions}
                      index={valueSupplierIds?.length}
                      setChildValue={setChildValueSupplierIds}
                    />
                    <ChipCmp
                      item={valueCustomerNationalCode}
                      enamValue={valueCustomerNationalCode}
                      index={valueCustomerNationalCode?.length}
                      setChildValue={setChildValueCustomerNationalCode}
                    />
                  </div>
                ) : (
                  ""
                )}
              </form>
            )}
          </Formik>
        </Box>
      ) : (
        ""
      )}
      <br />

      <div className="cardTableBorder">
        <TableContainer
          style={{ background: "#fff", maxHeight: "55vh" }}
          className="boxScroll"
        >
          <Table
            stickyHeader
            aria-label="sticky table"
            style={{ borderCollapse: "collapse" }}
          >
            <TableHead className="rowTHead" style={{ paddingBottom: "10px" }}>
              <TableRow
                classes={{ root: classes.select }}
                className={`${classes} borderRight borderLeft`}
                selected={selectedRow === 0}
              >
                <TableCell
                  className="rowTHead colorTitle textFont12 fontWeight WidthRowNumber"
                  align="right"
                  style={{ width: "10vh", minWidth: "10vh" }}
                >
                  #
                </TableCell>
                {columns.map((column) => (
                  <TableCell
                    className="rowTHead colorTitle textFont12 fontWeight noWrap"
                    key={column.id}
                    align="right"
                  >
                    {column.label}
                  </TableCell>
                ))}
                <TableCell
                  className="rowTHead colorTitle stickyColO"
                  align="right"
                >
                  <MoreHorizIcon
                    scale="scale(1.8) "
                    style={{ color: "#1D4A87" }}
                  />
                </TableCell>
              </TableRow>
            </TableHead>
            <div style={{ width: "100%", height: "10px" }}></div>
            <TableBody>
              {data
                ? data.map((row, rowIndex) => {
                    return (
                      <TableRow
                        classes={{ root: classes.select }}
                        className={`${
                          rowIndex % 2 == 0 ? "rowTBodyE  " : "rowTBodyO "
                        } ${classes} borderRight borderLeft cursorPointer noWrap`}
                        hover
                        role="checkbox"
                        tabIndex={-1}
                        // key={row.loanRequestId}
                        selected={selectedRow === rowIndex}
                        onClick={() => handleDetail(row.referenceKey, rowIndex)}
                      >
                        <TableCell
                          className="textFont12 WidthRowNumber"
                          style={{ width: "10vh", minWidth: "10vh" }}
                        >
                          {((currentPaginationInfo.pageNumber ?? 0) - 1) *
                            (currentPaginationInfo.pageSize! ?? 0) +
                            rowIndex +
                            1}
                        </TableCell>
                        {columns.map((column) => {
                          const value =
                            row[
                              column.id as keyof GetOnlineInstallmentReportResponse
                            ];
                          return (
                            <TableCell
                              className="textFont12"
                              key={column.id}
                              align="right"
                              style={
                                (column.id === "totalOverDuedDeptAmount" ||
                                  column.id === "penaltyAmount" ||
                                  column.id === "overduedInstallmentAmount" ||
                                  column.id === "overduedInstallmentCount") &&
                                Number(value) > 0
                                  ? { color: "red" }
                                  : {}
                              }
                            >
                              {column.format && column.hasFormat
                                ? column.format(value)
                                : value?.toString()}
                            </TableCell>
                          );
                        })}
                        <TableCell
                          className={
                            rowIndex % 2 == 0
                              ? " stickyColO   "
                              : " stickyColE  "
                          }
                        >
                          <MoreHorizIcon
                            scale="scale(1.8) "
                            className="cursorPointer"
                            style={{ color: "#1D4A87" }}
                            onClick={() =>
                              handleDetail(row.referenceKey, rowIndex)
                            }
                          />
                        </TableCell>
                      </TableRow>
                    );
                  })
                : null}
            </TableBody>
          </Table>
        </TableContainer>
      </div>
      <div>
        <Grid container spacing={2} alignItems="center">
          <Grid
            item
            xs={12}
            sm={4}
            display="flex"
            justifyContent={{ xs: "center", sm: "flex-start" }}
          >
            <span
              style={{ color: "#1D4A87", top: "1vh", position: "relative" }}
            >
              تعداد کل :
              <span style={{ color: "#01AF43" }}>{pageInfo.total}</span> مورد
            </span>
          </Grid>
          <Grid item xs={12} sm={4} display="flex" justifyContent="center">
            <Pagination
              renderItem={(item) => (
                <PaginationItem
                  components={{
                    previous: previusIcon,
                    next: nextIcon,
                  }}
                  {...item}
                />
              )}
              sx={{
                direction: "ltr",
                margin: "5px",
                button: {
                  color: "#25D1C9",
                  fontSize: "14px !important",
                  fontFamily: "iranSans",
                },
              }}
              count={
                pageInfo ? Math.ceil(pageInfo.total / pageInfo.pageSize) : 0
              }
              onChange={handleChangePagination}
              page={currentPaginationInfo.pageNumber}
            />
          </Grid>
          <Grid item xs={12} sm={4}></Grid>
        </Grid>
      </div>
    </div>
  );
}
interface TableCmpPropsInterface {
  stateCartable: any;
  status: any;
}
const mapStateToProps = ({ stateCartable, status }: TableCmpPropsInterface) => {
  return {
    stateCartable,
    status,
  };
};

export default withRouter(connect(mapStateToProps)(TableOnlineInstallment));
const onKeyDown = (e: any) => {
  e.preventDefault();
};
